import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DbEcertificateService } from '../../services/db-ecertificate.service';
import { UserModel } from './../../model/UserModel';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { validateAllFormFields } from '../../util/validateInput';
import Swal from 'sweetalert2';
import { AuthService } from '../../auth/auth.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [DbEcertificateService]
})

export class LoginComponent {
 userDetail: any = new UserModel();
  loginForm: FormGroup;
  isLoading: boolean = false;

 loginFormFormMessage: any;
 swal = require('sweetalert2');
  
  constructor(private _router: Router,
    public ECertificateService: DbEcertificateService,
    fb: FormBuilder,
    public authService: AuthService,
    private title: Title) {

    this.title.setTitle("E-Certificate Login");
    this.loginForm = new FormGroup({
      'emailAddress': new FormControl('', [Validators.required, Validators.email]),
      'passwords': new FormControl('', Validators.required),
    });
    this.loginFormFormMessage = {
      'emailAddress': {
        'required': "Please enter email address",
        'email' : "Please enter valid email address"
      },
      'passwords': {
        'required': "Please enter password"
      }
    }
  }

  login() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      (<HTMLInputElement>document.getElementById("btnLogin")).disabled = true;
      this.ECertificateService.login(this.userDetail.EmailId, this.userDetail.Password).then(res => {
        let userInfo = new UserModel();
        if (res["message"] == "Success" && res["item"] != null) {
          (<HTMLInputElement>document.getElementById("btnLogin")).disabled = false;
          this.isLoading = false;
          userInfo.CreateObject(res["item"]);
          this.authService.login(userInfo);
         //Swal('Oops...', 'Something went wrong!', 'error')
          this._router.navigate(['/admin/template']);
        }
        else {
          this.isLoading = false;
          (<HTMLInputElement>document.getElementById("btnLogin")).disabled = false;
          Swal('Oops...', res["message"], 'error');
        }
      });
    }
    else {
      validateAllFormFields(this.loginForm);
    }
  }


}
